// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1EQhC","itemTitle":"ClientEmergencyInfo_itemTitle__-nbN6","itemText":"ClientEmergencyInfo_itemText__3Z8hf"};